<template>
  <a
    type="action"
    :href="link"
    target="_blank"
    class="orange--text font-weight-bold help-center-link text-decoration-underline"
  >
    <slot />
  </a>
</template>

<script>
  import supportLink from '~/components/mixins/supportLink';

  export default {
    name: 'HelpCenterLink',
    mixins: [supportLink],
    props: {
      article: {
        type: String,
        default: null,
      },
    },
    computed: {
      link() {
        return this.supportLink(this.article);
      },
    },
  };
</script>

<style scoped>
.help-center-link {
  cursor: pointer;
}
</style>
